import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'var(--color-headings)',
    boxShadow: '0px 2px 12px 6px rgba(0, 0, 0, 0.1)',
    fontSize: 12,
    padding: '0.5rem 0.75rem',
    lineHeight: '1.25rem',
    maxWidth: '22rem',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--color-headings)',
  },
}));

export default CustomTooltip;